export function entries() {
	return [{ lang: 'en' }, { lang: 'no' }];
}
